import cn from 'classnames';

import Text from 'components/common/Text';
import PrivacyPolicy from 'components/shared/PrivacyPolicy';
import TermsOfService from 'components/shared/TermsOfService';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const SmsLegalText = ({ isPhoneNumberValid }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <Text
      brandStylesOverrides="textSm"
      className={cn('mb-8', isPhoneNumberValid ? 'text-charcoal-90' : 'text-charcoal-70')}
    >
      By clicking "Continue", I agree to receive recurring promotional text messages from{' '}
      {isTempo ? 'Tempo' : 'Home Chef'} {''}
      at the phone number provided. I also agree to {isTempo ? 'Tempo’s' : 'Home Chef’s'} {''}
      <TermsOfService
        classNames={cn(
          'underline textSm',
          isPhoneNumberValid ? 'text-charcoal-90' : 'text-charcoal-70'
        )}
        text="Terms and Conditions of Service"
      />{' '}
      and{' '}
      <PrivacyPolicy
        classNames={cn(
          'underline textSm',
          isPhoneNumberValid ? 'text-charcoal-90' : 'text-charcoal-70'
        )}
        text="Privacy Policy"
      />{' '}
      Consent is not a condition to purchase. Message & data rates may apply. Reply HELP for help &
      STOP to cancel.
    </Text>
  );
};

SmsLegalText.propTypes = {
  isPhoneNumberValid: PropTypes.bool,
};

export default SmsLegalText;
